export async function apiFetch<T>(url: string | URL, options: RequestInit | {
    body?: Record<string, any>
} = {}): Promise<T> {
    let body: BodyInit | undefined;
    const headers = {
        'Accept': 'application/json',
    } as Record<string, string>;
    if ('body' in options && options.body && typeof options.body === 'object' && !(options.body instanceof FormData)) {
        body = JSON.stringify(options.body);
        headers['Content-Type'] = 'application/json';
        delete options.body;
    }
    return await fetch(url, {
        method: "POST",
        body: body,
        headers: {
            ...headers,
            ...(options as RequestInit).headers || {},
        },
        cache: "no-cache",
        credentials: "omit",
        ...(options as RequestInit),
    }).then(async (r) => {
        if (!r.ok) {
            let msg;
            if (r.type === 'opaque') {
                msg = "API error with Opaque response. This usually means the request was blocked by CORS policy.";
            } else {
                msg = `API error with HTTP Status ${r.status}: ${r.statusText}`
                try {
                    const err = await r.json();
                    if (err && typeof err === 'object' && 'message' in err) {
                        msg = err.message;
                    } else if (typeof err === 'string') {
                        msg = err;
                    }
                } catch {
                    // Ignore JSON parsing errors
                }
            }
            throw new Error(msg);
        }
        return r.json()
    })
}